import PropTypes from 'prop-types';
import React from 'react';

import { Div, FlexCol } from 'common/styles/oc-styled-components';
import { colors } from 'common/styles/style-constants';
import {
  getMatchInsuranceToDisplay,
  getMatchTreatmentToDisplay,
} from 'utils/models/match-utils';
import { formatGender } from 'utils/string-utils';

export const ExistingMatchSearchOptions = ({
  match,
  location,
  locationLabel,
}) => {
  const searchOptions = [
    {
      label: locationLabel || 'Location',
      value: location?.formattedAddress || match?.location?.formattedAddress,
    },
    {
      label: 'Treatment',
      value: getMatchTreatmentToDisplay(match),
    },
    {
      label: 'Insurance',
      value: getMatchInsuranceToDisplay(match),
    },
    {
      label: 'Dentist Gender',
      value: formatGender(match?.other?.doctorGender),
    },
  ].filter(option => option.value);

  if (!searchOptions.length) {
    return null;
  }

  return (
    <FlexCol
      width="100%"
      margin="20px 0 0"
      padding="20px 0 0"
      style={{
        alignSelf: 'flex-start',
        gap: '10px',
        borderTop: `1px solid ${colors.gray14}`,
      }}
    >
      {searchOptions.map(option => (
        <FlexCol
          key={option.label}
          textAlign="left"
          style={{ fontSize: '13px', gap: '1px' }}
        >
          <Div style={{ fontWeight: 'bold' }}>{option.label}</Div>
          <Div>{option.value}</Div>
        </FlexCol>
      ))}
    </FlexCol>
  );
};

ExistingMatchSearchOptions.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object,
  locationLabel: PropTypes.string,
};
